import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import logo from "./../../assets/agencyIQ_Logo.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingLeft: theme.spacing(6),
  },
  ctaButton: {
    padding: 12,
    background: "#041E42",
    color: "white",
    borderRadius: 4,
    "&:hover": {
      background: "#28367B",
      color: "white",
    },
    marginTop: theme.spacing(4),
  },
  heading: {
    fontSize: 34,
    fontWeight: "bold",
    color: "#28367B",
    marginBottom: 10,
  },
  container: {
    marginTop: 20,
    width: 700,
    height: 400,
    background: "white",
    display: "flex",
    margin: "auto",
    borderRadius: 10,
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  card: {
    marginTop: 10,
    width: "100%",
    height: "auto",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  logo: {
    height: 80,
  },
  content: {
    margin: 10,
    textAlign: "center",
  },
  subHeading: {
    margin: 10,
    fontSize: 18,
    textAlign: "center",
    lineHeight: 2,
  },
}));

const FORM_REDIRECT_URL = process.env.REACT_APP_SIAA_INTEREST_FORM_URL;

export function UnavailableFeatureForCEO(props) {
  const classes = useStyles();

  const handleRedirect = () => {
    window.open(FORM_REDIRECT_URL, "_blank");
  };

  return (
    <Container className={classes.container}>
      <div className={classes.card}>
        <div className={classes.logoContainer}>
          <img className={classes.logo} src={logo} alt="AgencyIQ" />
        </div>
        <div className={classes.content}>
          <Typography className={classes.heading} style={{ fontWeight: 900 }}>
            Interested in This Feature?
          </Typography>
          <div className={classes.subHeading}>
            <Typography variant="h6">
              This feature is part of AgencyIQ Advanced Plan.
            </Typography>
            <Typography variant="h6">
              If you're interested in exploring access, let us know - we'll
              check if it's available for your agency and follow up with next
              steps.
            </Typography>
          </div>

          <Button
            classes={{
              root: classes.ctaButton,
            }}
            variant="outlined"

            onClick={handleRedirect}
          >
            Express Interest
          </Button>
        </div>
      </div>
    </Container>
  );
}

UnavailableFeatureForCEO.propTypes = {
  isBillingAllowed: PropTypes.bool.isRequired,
  feature: PropTypes.string,
};
